import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { scheduledApplicationsReducer } from './scheduled-applications.reducer';
import { ScheduledApplicationsEffects } from './scheduled-applications.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('scheduledApplications', scheduledApplicationsReducer),
    EffectsModule.forFeature([ScheduledApplicationsEffects]),
  ],
  providers: [],
})
export class ScheduledApplicationsStoreModule {}
